import { Link } from 'react-router';
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

export interface Crumb {
  label: string;
  href?: string;
}

export function Breadcrumbs({ items, className }: { items: Crumb[]; className?: string }) {
  return (
    <nav aria-label="Breadcrumb" className={cn("text-sm text-muted-foreground", className)}>
      <ol className="flex items-center gap-1 flex-wrap">
        {items.map((c, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1 min-w-0">
              {c.href && !isLast ? (
                <Link to={c.href} className="hover:text-muted-foreground focus-ring rounded">
                  {c.label}
                </Link>
              ) : (
                <span
                  className={cn(isLast && "text-foreground font-medium truncate")}
                  {...(isLast ? { "aria-current": "page" as const } : {})}
                >
                  {c.label}
                </span>
              )}
              {!isLast && <ChevronRight className="h-3.5 w-3.5 text-muted-foreground shrink-0" aria-hidden />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
